import React from "react";
import numberwithCommas from "components/common/numberWithCommas";
const ShowSarafi = ({ value, price, details }) => {
  return (
    <div className="card col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 bestSarafi mx-3">
      <div>
        <img
          src={value.exchange_logo}
          alt="icon"
          style={{ width: "60px", height: "60px" }}
        />
      </div>
      <br />
      <div style={{ fontWeight: "bold" }}>صرافی {value.exhnage_name}</div>
      <br />
      <div className="row">
        <div className="col-12">بهترین قیمت {details}</div>
        <div className="col-12">{numberwithCommas(price)}</div>
      </div>
    </div>
  );
};

export default ShowSarafi;
